import React from "react";

import "./DescriptiveLabel.css";

function DescriptiveLabel({ label, description }){
	return (
		<p key={label} className="label-with-description">
			{label}<span> {description}</span>
		</p>
	);
}

export default DescriptiveLabel;
